// extracted by mini-css-extract-plugin
module.exports = {"custom-scroll":"artworks_custom-scroll__CQasq","custom-scroll-visible":"artworks_custom-scroll-visible__TPURQ"};